const initialState = {
    targetEmail: [],
    emailSchedule: null,
    targetHour: null,
    timezone: "",
    targetDay: null,
    isEnabled: false
}
export default initialState;